import React from 'react';

const Features: React.FC = () => {
  const features = [
    {
      icon: (
        <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 24 24">
          <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      title: "Premium Quality",
      description: "Every fabric meets our exacting standards for texture, durability, and beauty.",
      iconColor: "text-royal-purple",
      bgColor: "bg-gradient-to-br from-lavender/40 to-amethyst/30",
      borderColor: "border-royal-purple/30"
    },
    {
      icon: (
        <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 24 24">
          <path d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
        </svg>
      ),
      title: "Sustainable Methods",
      description: "Eco-friendly processes that respect our planet while creating exceptional textiles.",
      iconColor: "text-teal-wave",
      bgColor: "bg-gradient-to-br from-mint/40 to-teal-wave/30",
      borderColor: "border-teal-wave/30"
    },
    {
      icon: (
        <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 24 24">
          <path d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
        </svg>
      ),
      title: "Award-Winning Design",
      description: "Recognized for innovative patterns and exceptional craftsmanship in textile design.",
      iconColor: "text-warm-gold",
      bgColor: "bg-gradient-to-br from-amber-glow/40 to-warm-gold/30",
      borderColor: "border-warm-gold/30"
    },
    {
      icon: (
        <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 24 24">
          <path d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      ),
      title: "Durability",
      description: "Built to last, our fabrics withstand the test of time and daily use.",
      iconColor: "text-ocean-blue",
      bgColor: "bg-gradient-to-br from-sky-blue/40 to-ocean-blue/30",
      borderColor: "border-ocean-blue/30"
    }
  ];

  return (
    <section className="section-padding bg-gradient-primary">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-gradient mb-6">
            Why Choose Vogueloom
          </h2>
          <p className="text-xl text-sage max-w-3xl mx-auto">
            Our commitment to excellence is woven into every thread, creating textiles that inspire and endure.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group h-full flex flex-col"
            >
              {/* Enhanced Glassmorphism Card with consistent height */}
              <div className="glass-card p-8 border-2 border-lavender/40 h-full flex flex-col justify-between hover:scale-105 transition-transform duration-300">
                {/* Top section with icon and title */}
                <div className="flex-1">
                  {/* Icon Container with consistent sizing */}
                  <div className={`${feature.bgColor} ${feature.borderColor} w-20 h-20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300 border-2`}>
                    <div className={`${feature.iconColor}`}>
                      {feature.icon}
                    </div>
                  </div>
                  
                  {/* Title with consistent typography */}
                  <h3 className="text-xl font-serif font-semibold text-charcoal mb-4 text-center">
                    {feature.title}
                  </h3>
                  
                  {/* Description with consistent formatting */}
                  <p className="text-sage leading-relaxed text-center text-base">
                    {feature.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
